module.exports = __webpack_public_path__ + "assets/img/txt-professionals-07.6bc8bbcd.svg";